import React from "react";
import PropTypes from "prop-types";

import { css } from 'emotion';

const CTAButton = ({ url, text, containerStyle, buttonStyle }) => (
  <form className={css`${containerStyle}`} method="get" action={url}>
      <button type="submit"  className={css`${buttonStyle}`}>
        {text}
      </button>
  </form>
);

CTAButton.propTypes = {
  url: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};


const buttonContainerStyles = css`
  flex: 1;
  //margin: 2rem 2rem 2rem;
  text-align:center;
  min-width:260px;
  
`
export default CTAButton;
